export const METADATA_FILTER_MATCH_TYPES = ["EQUALS", "CONTAINS"] as const

export const METADATA_FILTER_MATCH_TYPE = {
  EQUALS: METADATA_FILTER_MATCH_TYPES[0],
  CONTAINS: METADATA_FILTER_MATCH_TYPES[1],
} as const

export type MetadataFilterMatchType =
  (typeof METADATA_FILTER_MATCH_TYPES)[number]
